import { styled } from "@mui/material/styles";

const Img = styled("img")({
  margin: "auto",
  display: "block",
  width: "100%",
  borderRadius: "2px",
});

export default Img;
